import { useTranslation } from "react-i18next";
import { Select } from "../ui";
import { useDevice } from "../app/device";

/** `for: me | anyone` (spec §9.29): a per-device choice in the *Wants doing* header, which it filters (I-7); it
 * sat in the top bar, where it looked as if it filtered every list (UI cleanup U2). */
export function ForControl() {
  const { t } = useTranslation();
  const forWhom = useDevice((s) => s.forWhom);
  const setForWhom = useDevice((s) => s.setForWhom);
  return (
    <label className="flex items-center gap-1.5 text-[12.5px] text-neutral-500">
      <span>{t("circle.for.prefix")}</span>
      <Select
        className="h-[30px] py-0 text-[13px]"
        value={forWhom === "anyone" ? "anyone" : "me"}
        onChange={(e) => setForWhom(e.target.value)}
        aria-label={t("circle.for.prefix")}
        data-testid="for-control"
      >
        <option value="me">{t("circle.for.me")}</option>
        <option value="anyone">{t("circle.for.anyone")}</option>
      </Select>
    </label>
  );
}
